<template>
    <div>
        <h1 class="mb-8 font-bold text-3xl">
            <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('customers', {status: form.status})">Customers</inertia-link>
            <span class="text-indigo-400 font-medium">/Create</span>
        </h1>
        <div class="bg-white rounded shadow overflow-hidden max-w-3xl">
            <form @submit.prevent="submit">
                <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
                    <div class="pr-6 pb-8 w-full">
                        <div class="text-sm">
                            <input type="checkbox" v-model="form.none_tax" class="form-check input" :disabled="!editable">
                            Not tax-registered
                        </div>
                    </div>

                    <text-input :disabled="!editable" v-model="form.name" :errors="$page.props.errors.name" class="pr-6 pb-8 w-full lg:w-1/2" label="Customer Account Name" />
                    <text-input v-model="form.tin_number" :disabled="!editable || form.none_tax" :errors="$page.props.errors.tin_number" class="pr-6 pb-8 w-full lg:w-1/2" label="TIN Number" />

                    <text-input :disabled="!editable" v-model="form.ls_number" :errors="$page.props.errors.ls_number" class="pr-6 pb-8 w-full lg:w-1/2" label="LS Number" />
                    <select-input :disabled="!editable" v-model="form.business_type" :errors="$page.props.errors.business_type" class="pr-6 pb-8 w-full lg:w-1/2" label="Business Type">
                        <option :value="null" />
                        <option v-for="(btype, bkey) in business_types" :value="bkey" :key="bkey">{{ btype }}</option>
                    </select-input>



                    <select-input :disabled="!editable" v-model="form.atoll_id" :errors="$page.props.errors.atoll_id" class="pr-6 pb-8 w-full lg:w-1/2" label="Atoll">
                        <option :value="null" />
                        <option v-for="atoll in atoll_list" :value="atoll.id" :key="atoll.id">{{ atoll.name }}</option>
                    </select-input>

                    <select-input :disabled="!editable" v-model="form.island_id" :errors="$page.props.errors.island_id" class="pr-6 pb-8 w-full lg:w-1/2" label="Island" >
                        <option :value="null" />
                        <option v-if="form.atoll_id && form.atoll_id === irow.atoll_id" v-for="irow in island_list" :value="irow.id" :key="irow.id">{{ irow.name }}</option>
                    </select-input>

                    <div class="w-full  lg:w-1/2 pr-6 pb-8">
                        <select-input v-model="form.credit_customer" :errors="$page.props.errors.credit_customer" class="w-full" label="Is Credit Customer">
                            <option :value="false">No</option>
                            <option :value="true">Yes</option>
                        </select-input>
                    </div>

                    <div class="w-full  lg:w-1/2 pr-6 pb-8">
                        <select-input v-model="form.status" :errors="$page.props.errors.status" class="w-full" label="Status">
                            <option :value="null" />
                            <option v-for="(status, skey) in $page.props.statuses" :value="skey" :key="skey">{{ status }}</option>
                        </select-input>
                    </div>
                </div>



                <div class="px-8 py-4 bg-gray-100 border-t border-gray-200 flex items-center">
                    <loading-button :loading="sending" class="btn-primary ml-auto" type="submit">Create Customer</loading-button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
  import Icon from '@/Shared/Icon'
  import Layout from '@/Shared/Admin/Layout'
  import LoadingButton from '@/Shared/LoadingButton'
  import SelectInput from '@/Shared/SelectInput'
  import TextInput from '@/Shared/TextInput'
  import TrashedMessage from '@/Shared/TrashedMessage'
  import DeliveryAddressCard from '@/Shared/DeliveryAddressCard'
  import CustomerUsers from './CustomerUsers'

  export default {
    metaInfo() {
      return { title: this.form.name }
    },
    layout: Layout,
    components: {
      CustomerUsers,
      DeliveryAddressCard,
      Icon,
      LoadingButton,
      SelectInput,
      TextInput,
      TrashedMessage,
      DeliveryAddressCard,
      CustomerUsers
    },
    props: {
      statuses: Object,
      similar: Array,
      business_types: Object,
      locations: Object,
      atoll_list: Array,
      island_list: Array
    },
    remember: 'form',
    data() {
      return {
        sending: false,
        editable: true,
        form: {
          none_tax: false,
          name: null,
          ls_number: null,
          tin_number: null,
          location: null,
          status: null,
          business_type: null,
          atoll_id: null,
          island_id: null
        }
      }
    },

    watch: {
      'form.none_tax': function(val) {
        if(val) {
          this.form.tin_number = null;
        }
      }
    },
    methods: {
      submit() {
        this.sending = true
        this.$inertia.post(this.route('customers.store'), this.form,{
          onFinish : () => this.sending = false
        })

      },

      getIslandName(islandCode) {
        if(this.island_list.length) {
          let found = this.island_list.find(island => island.code == islandCode);

          if(found) {
            return found.island
          }
        }

        return null
      }
    },
  }
</script>
